export default __webpack_public_path__ + "static/media/defaultImg.d831ab24.svg";